import React from "react";
import Layout from "../components/layout/LandingPageLayout";

// Direct imports (no lazy loading)
import Home from "../components/LandingPageComponets/Home";
import CTA from "../components/LandingPageComponets/CTA";
import Partners from "../components/LandingPageComponets/Partners";
import WhyChooseUs from "../components/LandingPageComponets/WhyChooseUs";
import CutomizeSolution from "../components/LandingPageComponets/CutomizeSolution";
import Guidelines from "../components/LandingPageComponets/Guidelines";
import FAQ from "../components/LandingPageComponets/FAQ";
import Testimonials from "./Testimonials";


const LandingPage = () => {
  return (
    <Layout>
      <Home />
      <Guidelines />
      <CutomizeSolution />
      <WhyChooseUs />
      <Partners />
      <Testimonials/>
      <FAQ />
      <CTA />
    </Layout>
  );
};

export default LandingPage;



